import React from "react";
import { Fragment } from "react";

function EditWorkTypeHeader() {
  return (
    <Fragment>
      <div className="row customers shopHeader">
        <div className="col-sm-12 addWorkOrderTypw">
          <h2>Edit Work Order Type</h2>
        </div>
      </div>
    </Fragment>
  );
}

export default EditWorkTypeHeader;
